import { render, staticRenderFns } from "./Hotspot.vue?vue&type=template&id=552ed4f0&scoped=true&"
import script from "./Hotspot.vue?vue&type=script&lang=js&"
export * from "./Hotspot.vue?vue&type=script&lang=js&"
import style0 from "./Hotspot.vue?vue&type=style&index=0&id=552ed4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552ed4f0",
  null
  
)

export default component.exports